import { cn } from '@/lib/utils'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import { CardType } from '@/v2/types/cards'
import { useState } from 'react'

export default function NewsArticle({ article, imgClassName }: { article: CardType; imgClassName?: string }) {
  const [showDescription, setShowDescription] = useState(false)

  return (
    <article className='[&>h3]:mb-3 xl-min:[&>h3]:text-xl [&>h3]:text-lg [&>h3]:font-semibold [&>h3]:text-paragraph [&>h3]:leading-8'>
      {article.image && (
        <div>
          <ResponsiveImage
            src={article.image.src}
            alt={article.image.alt}
            className={cn('h-[270px] w-[359px]', imgClassName)}
          />
        </div>
      )}

      <h3>{article.title}</h3>
      <p className='text-paragraph leading-6 text-base font-normal'>
        {!showDescription && (
          <>
            {article.description?.slice(0, 70)}.....{' '}
            <span className='text-heading-home font-semibold cursor-pointer' onClick={() => setShowDescription(true)}>
              Read more
            </span>
          </>
        )}
        {showDescription && (
          <>
            {article.description}
            <br />
            <span className='text-heading-home font-semibold cursor-pointer' onClick={() => setShowDescription(false)}>
              Read less!
            </span>
          </>
        )}
      </p>
    </article>
  )
}
